import {
    Grid,
  } from '@mui/material';
  import clsx from 'clsx';
  import { useStyles } from './style';
const TreeShimmerLoading = () => {
    const classes = useStyles();

    return (
        <Grid xs={12} lg={5} md={5} sm={5} style={{ marginBottom: '16px' , marginTop: '32px' }}>
            <div style={{ display: 'flex' }}>
                <div className={clsx(classes.shimmerBG, classes.contentCheckbox)}></div>
                <div className={clsx(classes.shimmerBG, classes.contentLine)}></div>
            </div>
            <div style={{ display: 'flex', marginRight: '24px' }}>
                <div className={clsx(classes.shimmerBG, classes.contentCheckbox)}></div>
                <div className={clsx(classes.shimmerBG, classes.contentLine)}></div>
            </div>
            <div style={{ display: 'flex', marginRight: '48px' }}>
                <div className={clsx(classes.shimmerBG, classes.contentCheckbox)}></div>
                <div className={clsx(classes.shimmerBG, classes.contentLine)}></div>
            </div>
        </Grid>
    )

}
export default TreeShimmerLoading;